import { Aangifte, DomainError } from "domain/aangifte";
import { Rubriek as RubriekType } from "domain/store/rubriekenReducer";
import { Value } from "domain/types";
import { either } from "fp-ts";
import { pipe } from "fp-ts/lib/function";
import { ChangeBurgerlijkeStaatWarning } from "pages/personalTaxPage/ChangeBurgerlijkeStaatWarning";
import { FunctionComponent, useState } from "react";
import { useAangifte } from "./AangifteProvider";

interface RenderProps {
  rubriek: RubriekType;
  updateValue: (value?: Value) => either.Either<DomainError, Aangifte>;
}
export interface Props {
  code: string;
  children(props: RenderProps): JSX.Element | null;
}

export const Rubriek: FunctionComponent<Props> = ({ code, children }) => {
  const [error, setError] = useState<DomainError>();
  const { aangifte, dispatch } = useAangifte();
  const rubriek = aangifte.rubrieken.get(code);

  const updateValue = (value?: Value) => {
    return pipe(
      dispatch({ type: "UPDATE_RUBRIEK_VALUE", value, code }),
      either.mapLeft((e) => {
        setError(e);
        return e;
      })
    );
  };

  const renderError = () => {
    if (!error) return null;
    switch (error.type) {
      case "WARNING_PARTNER_CODES_FILLED_IN_FOR_SINGLE_AANGIFTE":
        return (
          <ChangeBurgerlijkeStaatWarning
            onClose={() => setError(undefined)}
            filledInPartnerCodes={error.partnerCodes}
            action={error.action}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      {renderError()}
      {rubriek && children({ rubriek, updateValue })}
    </>
  );
};

Rubriek.displayName = "Rubriek";
